// extracted by mini-css-extract-plugin
export default {"navbar":"Navbar_navbar__66Kq7","list":"Navbar_list__I4TWn"};